import { Column } from './Column';
import { From } from './From';
export var View;
(function (View) {
    function make(from, name, opts = {}) {
        const attrs = opts.attrs || [];
        return {
            name,
            from,
            ...opts,
            attrs,
        };
    }
    View.make = make;
    function extend(parent, child) {
        return {
            ...child,
            from: From.view(parent.name),
            attrs: Attrs.extend(parent, child.attrs),
        };
    }
    View.extend = extend;
    let Joins;
    (function (Joins) {
        function add(view, join) {
            const joins = view.joins || [];
            const index = indexOf(view, join.alias);
            if (index === -1) {
                return { ...view, joins: [...joins, join] };
            }
            else {
                return { ...view, joins: joins.slice().fill(join, index, index + 1) };
            }
        }
        Joins.add = add;
        function indexOf(view, alias) {
            let index = 0;
            for (const join of view.joins || []) {
                if (join.alias === alias) {
                    return index;
                }
                index++;
            }
            return -1;
        }
        Joins.indexOf = indexOf;
    })(Joins = View.Joins || (View.Joins = {}));
    let Attrs;
    (function (Attrs) {
        function add(view, attr) {
            const attrs = view.attrs;
            const index = indexOf(view, attr.name);
            if (index === -1) {
                return { ...view, attrs: [...attrs, attr] };
            }
            else {
                return { ...view, attrs: attrs.slice().fill(attr, index, index + 1) };
            }
        }
        Attrs.add = add;
        function indexOf(view, name) {
            return view.attrs.findIndex((attr) => attr.name === name);
        }
        Attrs.indexOf = indexOf;
        function extend(view, attrs) {
            const vAttrs = new Map();
            for (const attr of view.attrs) {
                vAttrs.set(attr.name, attr);
            }
            for (const attr of attrs) {
                vAttrs.set(attr.name, attr);
            }
            return Array.from(vAttrs.values());
        }
        Attrs.extend = extend;
    })(Attrs = View.Attrs || (View.Attrs = {}));
    let Calcs;
    (function (Calcs) {
        function all(view) {
            const calcs = new Array();
            for (const attr of view.attrs) {
                if (attr.source === "CALC") {
                    calcs.push(attr);
                }
            }
            return calcs;
        }
        Calcs.all = all;
        function filter(view, filterFn) {
            const vCalcs = new Array();
            for (const calc of all(view)) {
                if (filterFn(calc)) {
                    vCalcs.push(calc);
                }
            }
            const attrs = [...Columns.all(view), ...vCalcs];
            return {
                ...view,
                attrs,
            };
        }
        Calcs.filter = filter;
        function replace(view, ...calcs) {
            const tCalcs = new Map();
            for (const calc of all(view)) {
                tCalcs.set(calc.name, calc);
            }
            for (const calc of calcs) {
                tCalcs.set(calc.name, calc);
            }
            const attrs = [...Columns.all(view), ...tCalcs.values()];
            return {
                ...view,
                attrs,
            };
        }
        Calcs.replace = replace;
    })(Calcs = View.Calcs || (View.Calcs = {}));
    let Columns;
    (function (Columns) {
        function all(view) {
            const columns = new Array();
            for (const attr of view.attrs) {
                if (attr.source === "COLUMN") {
                    columns.push(attr);
                }
            }
            return columns;
        }
        Columns.all = all;
        function filter(view, filterFn) {
            const vColumns = new Array();
            for (const column of all(view)) {
                if (filterFn(column)) {
                    vColumns.push(column);
                }
            }
            const attrs = [...vColumns, ...Calcs.all(view)];
            return {
                ...view,
                attrs,
            };
        }
        Columns.filter = filter;
        function merge(view, ...columns) {
            const vColumns = new Map();
            for (const column of all(view)) {
                vColumns.set(column.name, column);
            }
            for (const column of columns) {
                const existing = vColumns.get(column.name);
                if (existing == null) {
                    vColumns.set(column.name, column);
                }
                else {
                    vColumns.set(column.name, Column.merge(existing, column));
                }
            }
            const attrs = Array.from(vColumns.values());
            return {
                ...view,
                attrs,
            };
        }
        Columns.merge = merge;
        function replace(view, ...columns) {
            const vColumns = new Map();
            for (const column of all(view)) {
                vColumns.set(column.name, column);
            }
            for (const column of columns) {
                vColumns.set(column.name, column);
            }
            const attrs = Array.from(vColumns.values());
            return {
                ...view,
                attrs,
            };
        }
        Columns.replace = replace;
    })(Columns = View.Columns || (View.Columns = {}));
})(View || (View = {}));
